// @flow

import { noop } from '@boi/core/lib/utils';
import type { Node } from 'react';
import React from 'react';

import { edgeAriaLabel } from '../../helpers';

type Props = {
  url: string,
  className?: string,
  onClick?: noop,
  style?: { [string]: string },
  linkAriaLabel?: string
};

type ExternalLinkProps = Props & { text: string };
type ExternalLinkWrapperProps = Props & { children: Node };

const LINK_LABEL = 'Link opens in a new tab or is downloaded';

export const ExternalLink = (props: ExternalLinkProps) =>
  ExternalLinkWrapper({ ...props, children: props.text });

export const ExternalLinkWrapper = ({
                                      children,
                                      url,
                                      className,
                                      style,
                                      onClick,
                                      linkAriaLabel
                                    }: ExternalLinkWrapperProps) => {
  const ariaLabel = linkAriaLabel ? linkAriaLabel : LINK_LABEL;
  return (
    <a
      rel="noopener noreferrer"
      target="_blank"
      href={url}
      className={className}
      onClick={onClick}
      aria-label={ariaLabel}
      style={style}
    >
      {edgeAriaLabel(ariaLabel)}
      {children}
    </a>
  );
};
